import * as tslib_1 from "tslib";
/* tslint:disable:no-unused-variable */
import * as React from 'react';
/* tslint:enable:no-unused-variable */
import * as PropTypes from 'prop-types';
import { BaseComponent, classNamesFunction, customizable, divProperties, getNativeProps, createRef } from '../../Utilities';
var getClassNames = classNamesFunction();
var ScrollablePaneBase = /** @class */ (function (_super) {
    tslib_1.__extends(ScrollablePaneBase, _super);
    function ScrollablePaneBase(props) {
        var _this = _super.call(this, props) || this;
        _this._root = createRef();
        _this._stickyAboveRef = createRef();
        _this._stickyBelowRef = createRef();
        _this.subscribe = function (handler) {
            _this._subscribers.add(handler);
        };
        _this.unsubscribe = function (handler) {
            _this._subscribers.delete(handler);
        };
        _this.addStickyHeader = function (sticky) {
            _this._addSticky(sticky, _this._stickyAbove, function () {
                if (_this._stickyAboveRef.value) {
                    _this._stickyAboveRef.value.appendChild(sticky.content);
                }
            });
        };
        _this.addStickyFooter = function (sticky) {
            _this._addSticky(sticky, _this._stickyBelow, function () {
                if (_this._stickyBelowRef.value) {
                    _this._stickyBelowRef.value.insertBefore(sticky.content, _this._stickyBelowRef.value.firstChild);
                }
            });
        };
        _this.removeStickyHeader = function (sticky) {
            _this._removeSticky(sticky, _this._stickyAbove, _this._stickyAboveRef.value);
        };
        _this.removeStickyFooter = function (sticky) {
            _this._removeSticky(sticky, _this._stickyBelow, _this._stickyBelowRef.value);
        };
        _this.notifySubscribers = function (sort) {
            _this._subscribers.forEach(function (handle) {
                if (_this._stickyAboveRef.value && _this._stickyBelowRef.value) {
                    handle(_this._stickyAboveRef.value.getBoundingClientRect(), _this._stickyBelowRef.value.getBoundingClientRect());
                }
            });
            if (_this._stickyAbove.size > 1) {
                _this._sortStickies(_this._stickyAbove, _this._stickyAboveRef.value);
            }
            if (_this._stickyBelow.size > 1) {
                _this._sortStickies(_this._stickyBelow, _this._stickyBelowRef.value);
            }
        };
        _this.getScrollPosition = function () {
            if (_this._root.value) {
                return _this._root.value.scrollTop;
            }
            return 0;
        };
        _this._setPlaceholderHeights = function (stickies) {
            stickies.forEach(function (sticky, idx) {
                sticky.setPlaceholderHeight(sticky.content.clientHeight);
            });
        };
        _this._subscribers = new Set();
        _this._stickyAbove = new Set();
        _this._stickyBelow = new Set();
        return _this;
    }
    Object.defineProperty(ScrollablePaneBase.prototype, "root", {
        get: function () {
            return this._root.value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScrollablePaneBase.prototype, "stickyAbove", {
        get: function () {
            return this._stickyAboveRef.value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScrollablePaneBase.prototype, "stickyBelow", {
        get: function () {
            return this._stickyBelowRef.value;
        },
        enumerable: true,
        configurable: true
    });
    ScrollablePaneBase.prototype.getChildContext = function () {
        return {
            scrollablePane: {
                subscribe: this.subscribe,
                unsubscribe: this.unsubscribe,
                addStickyHeader: this.addStickyHeader,
                removeStickyHeader: this.removeStickyHeader,
                addStickyFooter: this.addStickyFooter,
                removeStickyFooter: this.removeStickyFooter,
                notifySubscribers: this.notifySubscribers
            }
        };
    };
    ScrollablePaneBase.prototype.componentDidMount = function () {
        this._events.on(this._root.value, 'scroll', this.notifySubscribers);
        this._events.on(window, 'resize', this._onWindowResize);
    };
    ScrollablePaneBase.prototype.componentWillUnmount = function () {
        this._events.off(this._root.value);
        this._events.off(window);
    };
    ScrollablePaneBase.prototype.componentDidUpdate = function (prevProps) {
        var initialScrollPosition = this.props.initialScrollPosition;
        if (this._root.value && initialScrollPosition && prevProps.initialScrollPosition !== initialScrollPosition) {
            this._root.value.scrollTop = initialScrollPosition;
        }
    };
    ScrollablePaneBase.prototype.render = function () {
        var _a = this.props, className = _a.className, theme = _a.theme, getStyles = _a.getStyles;
        var classNames = getClassNames(getStyles, {
            theme: theme,
            className: className
        });
        return (React.createElement("div", tslib_1.__assign({}, getNativeProps(this.props, divProperties), { ref: this._root, className: classNames.root }),
            React.createElement("div", { ref: this._stickyAboveRef, className: classNames.stickyAbove }),
            React.createElement("div", { ref: this._stickyBelowRef, className: classNames.stickyBelow }),
            React.createElement("div", { "data-is-scrollable": true }, this.props.children)));
    };
    ScrollablePaneBase.prototype.forceLayoutUpdate = function () {
        this._onWindowResize();
    };
    ScrollablePaneBase.prototype._addSticky = function (sticky, stickyList, addStickyToContainer) {
        if (!stickyList.has(sticky)) {
            stickyList.add(sticky);
            addStickyToContainer();
            sticky.content.addEventListener('transitionend', this._setPlaceholderHeights.bind(null, stickyList), false);
            if (sticky.props.stickyClassName) {
                this._async.setTimeout(function () {
                    if (sticky.props.stickyClassName) {
                        sticky.content.children[0].classList.add(sticky.props.stickyClassName);
                    }
                }, 1);
            }
            this._setPlaceholderHeights(stickyList);
        }
    };
    ScrollablePaneBase.prototype._removeSticky = function (sticky, stickyList, container) {
        if (container && stickyList.has(sticky)) {
            sticky.content.removeEventListener('transitionend', this._setPlaceholderHeights.bind(null, stickyList, container));
            stickyList.delete(sticky);
        }
    };
    ScrollablePaneBase.prototype._onWindowResize = function () {
        var _this = this;
        this._async.setTimeout(function () {
            _this.notifySubscribers();
            _this._setPlaceholderHeights(_this._stickyAbove);
            _this._setPlaceholderHeights(_this._stickyBelow);
        }, 5);
    };
    ScrollablePaneBase.prototype._sortStickies = function (stickyList, container) {
        var _this = this;
        // No sorting needed if there is no container
        if (!container) {
            return;
        }
        var stickyArr = Array.from(stickyList);
        stickyArr = stickyArr.sort(function (a, b) {
            var aOffset = _this._calculateOffsetParent(a.root.value);
            var bOffset = _this._calculateOffsetParent(b.root.value);
            return aOffset - bOffset;
        });
        // Get number of elements that is already in order.
        var elementsInOrder = 0;
        while (elementsInOrder < container.children.length && elementsInOrder < stickyArr.length) {
            if (container.children[elementsInOrder] === stickyArr[elementsInOrder].content) {
                ++elementsInOrder;
            }
            else {
                break;
            }
        }
        // Remove elements that is not in order if exist.
        for (var i = container.children.length - 1; i >= elementsInOrder; --i) {
            container.removeChild(container.children[i]);
        }
        // Append further elements if needed.
        for (var i = elementsInOrder; i < stickyArr.length; ++i) {
            container.appendChild(stickyArr[i].content);
        }
    };
    ScrollablePaneBase.prototype._calculateOffsetParent = function (ele) {
        var offset = 0;
        while (ele && this._root.value && ele.offsetParent !== this._root.value.offsetParent) {
            offset += ele.offsetTop;
            if (ele.parentElement) {
                ele = ele.parentElement;
            }
        }
        return offset;
    };
    ScrollablePaneBase.childContextTypes = {
        scrollablePane: PropTypes.object
    };
    ScrollablePaneBase = tslib_1.__decorate([
        customizable('ScrollablePane', ['theme'])
    ], ScrollablePaneBase);
    return ScrollablePaneBase;
}(BaseComponent));
export { ScrollablePaneBase };
//# sourceMappingURL=ScrollablePane.base.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib-es2015/components/ScrollablePane/ScrollablePane.base.js
// module id = 303
// module chunks = 0